/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { Button, Switch } from 'sarsaparilla';
import { type AuthSession } from 'shared-ui/auth/redux';
import { useTripPreferences } from './TripPreferenceContext';
import TripPreferencesModal from './TripPreferencesModal';

interface TripPreferencesBarProps {
    account: AuthSession | null;
}

export function TripPreferencesBar({ account }: TripPreferencesBarProps) {
    const {
        loadingPreferences,
        onApplyPreferences,
        onDisablePreferences,
        isEnabled,
        onPreferenceModal,
        onOpenManagementAfterLogin,
    } = useTripPreferences();

    const handlePreferencesSwitch = React.useCallback(() => {
        if (isEnabled) {
            onDisablePreferences();
        } else {
            onApplyPreferences();
        }
    }, [isEnabled, onDisablePreferences, onApplyPreferences]);

    const handleManagementModal = React.useCallback(() => {
        onPreferenceModal(true);

        if (!account?.account?.account_id) {
            onOpenManagementAfterLogin(true);
        }
    }, [account?.account?.account_id, onPreferenceModal, onOpenManagementAfterLogin]);

    return (
        <>
            <div className="search-filters-section-preferences my-2">
                <div>
                    <Switch
                        isSelected={isEnabled}
                        label="Apply Trip Preferences"
                        isDisabled={loadingPreferences}
                        onChange={handlePreferencesSwitch}
                        id="trip-toggle-preferences"
                        clickTagCategory="Search Results Filters"
                        clickTagLabel="Apply Trip Preferences Toggle"
                    />
                </div>
                <div>
                    <Button
                        onClick={handleManagementModal}
                        appearance="link"
                        clickTagCategory="Search Results Filters"
                        clickTagAction="Open Trip Preferences Modal"
                        clickTagLabel="Manage Trip Preferences"
                    >
                        Manage Trip Preferences
                    </Button>
                </div>
            </div>

            <TripPreferencesModal />
        </>
    );
}
